import React from "react";
import { Redirect } from "react-router-dom";

import Login from "../pages/auth/Login";
import TwoFactorAuth from "../pages/auth/TwoFactorAuth";
import LoginTwoFactorAuth from "../pages/auth/LoginTwoFactorAuth";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";

import AdminsList from "../pages/dashboard/admins/AdminsList";
import AddAdmin from "../pages/dashboard/admins/AddAdmin";
import EditAdmin from "../pages/dashboard/admins/EditAdmin";
import EditProfile from "../pages/dashboard/admins/EditProfile";
import RolesList from "../pages/dashboard/roles/RolesList";
import AddRole from "../pages/dashboard/roles/AddRole";
import EditRole from "../pages/dashboard/roles/EditRole";
import EditEmployee from "../pages/dashboard/employees/EditEmployee";
import AddEmployee from "../pages/dashboard/employees/AddEmployee";
import EmployeesList from "../pages/dashboard/employees/EmployeesList";
import EditCompany from "../pages/dashboard/companies/EditCompany";
import AddCompany from "../pages/dashboard/companies/AddCompany";
import CompaniesList from "../pages/dashboard/companies/CompaniesList";
import ContractsList from "../pages/dashboard/companies/contracts/ContractsList";
import AddContract from "../pages/dashboard/companies/contracts/AddContract";
import EditContract from "../pages/dashboard/companies/contracts/EditContract";

import ContactsList from "../pages/dashboard/companies/contacts/ContactsList";
import AddContact from "../pages/dashboard/companies/contacts/AddContact";
import EditContact from "../pages/dashboard/companies/contacts/EditContact";
import CompanyProfile from "../pages/dashboard/companies/CompanyProfile";
import FeesList from "../pages/dashboard/companies/fees/FeesList";
import AddFee from "../pages/dashboard/companies/fees/AddFee";
import EditFee from "../pages/dashboard/companies/fees/EditFee";
import PoolsList from "../pages/dashboard/contracts/pools/PoolsList";
import AddPool from "../pages/dashboard/contracts/pools/AddPool";
import EditPool from "../pages/dashboard/contracts/pools/EditPool";
import MyContractsList from "../pages/dashboard/contracts/ContractsList";
import CollectionsList from "../pages/dashboard/contracts/hours-collection/CollectionsList";
import EditCollection from "../pages/dashboard/contracts/hours-collection/EditCollection";
import AddCollection from "../pages/dashboard/contracts/hours-collection/AddCollection";
import InvoiceablesList from "../pages/dashboard/contracts/invoiceables/InvoiceablesList";
import AddInvoiceable from "../pages/dashboard/contracts/invoiceables/AddInvoiceable";
import EditInvoiceable from "../pages/dashboard/contracts/invoiceables/EditInvoiceable";
import InvoicesList from "../pages/dashboard/contracts/invoices/InvoicesList";
import AddInvoice from "../pages/dashboard/contracts/invoices/AddInvoice";
import PriceComponentsList from "../pages/dashboard/price-components/PriceComponentsList";
import AddPriceComponent from "../pages/dashboard/price-components/AddPriceComponent";
import EditPriceComponent from "../pages/dashboard/price-components/EditPriceComponent";
import PayslipesList from "../pages/dashboard/payslipes/PayslipesList";
import AddPayslipe from "../pages/dashboard/payslipes/AddPayslipe";
import PayslipeDetails from "../pages/dashboard/payslipes/PayslipeDetails";
import DeductionsList from "../pages/dashboard/deductions/DeductionsList";
import AddDeduction from "../pages/dashboard/deductions/AddDeduction";
import EmployeeProfile from "../pages/dashboard/employees/EmployeeProfile";
import AddWorkExperience from "../pages/dashboard/employees/AddWorkExperience";
import EditWorkExperience from "../pages/dashboard/employees/EditWorkExperience";
import AddEducation from "../pages/dashboard/employees/AddEducation";
import EditEducation from "../pages/dashboard/employees/EditEducation";
import InsuranceList from "../pages/dashboard/insurance/InsuranceList";
import EditInsurance from "../pages/dashboard/insurance/EditInsurance";
import AddInsurance from "../pages/dashboard/insurance/AddInsurance";
import InternalPayslipesList from "../pages/dashboard/internal-payslipes/InternalPayslipesList";
import InternalPayslipeDetails from "../pages/dashboard/internal-payslipes/InternalPayslipeDetails";
import AddInternalPayslipe from "../pages/dashboard/internal-payslipes/AddInternalPayslipe";
import HoursSheet from "../pages/dashboard/contracts/invoices/HoursSheet";
import CarsList from "../pages/dashboard/cars/CarsList";
import AddCar from "../pages/dashboard/cars/AddCar";
import EditCar from "../pages/dashboard/cars/EditCar";
import HousingList from "../pages/dashboard/housing/HousingList";
import AddHousing from "../pages/dashboard/housing/AddHousing";
import EditHousing from "../pages/dashboard/housing/EditHousing";
import RoomsList from "../pages/dashboard/housing/rooms/RoomsList";
import AddRoom from "../pages/dashboard/housing/rooms/AddRoom";
import EditRoom from "../pages/dashboard/housing/rooms/EditRoom";
import CarDetails from "../pages/dashboard/cars/CarDetails";
import ReservationsList from "../pages/dashboard/reservations/ReservationsList";
import HousingDetails from "../pages/dashboard/housing/HousingDetails";
import RoomDetails from "../pages/dashboard/housing/rooms/RoomDetails";
import ReservationDetails from "../pages/dashboard/reservations/ReservationDetails";
import FineList from "../pages/dashboard/reservations/fine/FineList";
import AddFine from "../pages/dashboard/reservations/fine/AddFine";
import EditFine from "../pages/dashboard/reservations/fine/EditFine";
import PersonalUseList from "../pages/dashboard/reservations/personal-use/PersonalUseList";
import EditPersonalUse from "../pages/dashboard/reservations/personal-use/EditPersonalUse";
import AddPersonalUse from "../pages/dashboard/reservations/personal-use/AddPersonalUse";
import LeavesList from "../pages/dashboard/holidays/LeavesList";
import AddLeave from "../pages/dashboard/holidays/AddLeave";
import EditLeave from "../pages/dashboard/holidays/EditLeave";
import RoomRentersList from "../pages/dashboard/housing/rooms/renters/RoomRentersList";
import CarRentersList from "../pages/dashboard/cars/renters/CarRentersList";
import HousingRentersList from "../pages/dashboard/housing/renters/HousingRentersList";
import InvoiceDetailsPage from "../pages/dashboard/contracts/invoices/InvoiceDetailsPage";
import InvoiceDetailsPreview from "../pages/dashboard/contracts/invoices/InvoiceDetailsPreview";
import HourCollectionsList from "../pages/dashboard/hour-collection/HourCollectionsList";

const adminRoutes = [
  {
    path: "/admins",
    component: AdminsList,
  },
  // {
  //   path: "/my-admins",
  //   component: MyAdminsList,
  // },
  {
    path: "/add-admin",
    component: AddAdmin,
  },
  {
    path: "/edit-admin/:id",
    component: EditAdmin,
  },
  // {
  //   path: "/get-admin/:id",
  // },
  { path: "/edit-profile", component: EditProfile },
  { path: "/roles", component: RolesList },
  {
    path: "/add-role",
    component: AddRole,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
  {
    path: "/edit-role/:id",
    component: EditRole,
    // permission: PERMISSIONS.ROLE_EDIT,
  },
];

const employeeRoutes = [
  { path: "/employees", component: EmployeesList },
  { path: "/employees/:id", component: EmployeeProfile },

  {
    path: "/add-employee",
    component: AddEmployee,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
  {
    path: "/edit-employee/:id",
    component: EditEmployee,
    // permission: PERMISSIONS.ROLE_EDIT,
  },
  {
    path: "/employees/:employeeId/price-components",
    component: PriceComponentsList,
  },
];

const poolRoutes = [
  { path: "/pools", component: PoolsList },
  {
    path: "/add-pool/:contractId",
    component: AddPool,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
  {
    path: "/edit-pool/:id",
    component: EditPool,
    // permission: PERMISSIONS.ROLE_EDIT,
  },
];

const companyRoutes = [
  { path: "/companies", component: CompaniesList },
  {
    path: "/add-company",
    component: AddCompany,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
  {
    path: "/edit-company/:id/:action",
    component: EditCompany,
    // permission: PERMISSIONS.ROLE_EDIT,
  },

  { path: "/company/:id", component: CompanyProfile },

  { path: "/company/:id/contacts", component: ContactsList },
  {
    path: "/company/:id/add-contact",
    component: AddContact,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
  {
    path: "/edit-contact/:contactId",
    component: EditContact,
    // permission: PERMISSIONS.ROLE_EDIT,
  },

  /*{ path: "/company/:id/fees", component: FeesList },
  {
    path: "/company/:id/add-fee",
    component: AddFee,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
  {
    path: "/edit-fee/:feeId",
    component: EditFee,
    // permission: PERMISSIONS.ROLE_EDIT,
  },*/
];

const invoiceRoutes = [
  { path: "/invoices", component: InvoicesList },

  { path: "/contract-invoices/:contractId", component: InvoicesList },
  {
    path: "/add-invoice",
    component: AddInvoice,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
  { path: "/invoices/:invoiceId", component: InvoiceDetailsPage },
  { path: "/invoices/preview/:contractId", component: InvoiceDetailsPreview },
  { path: "/hours-sheet/:invoiceId", component: HoursSheet },
];

const invoiceableRoutes = [
  { path: "/contract-invoiceables/:contractId", component: InvoiceablesList },
  {
    path: "/add-invoiceable/:contractId",
    component: AddInvoiceable,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
  {
    path: "/edit-invoiceable/:id",
    component: EditInvoiceable,
    // permission: PERMISSIONS.ROLE_EDIT,
  },
];

const priceComponentRoutes = [
  { path: "/price-components", component: PriceComponentsList },
  { path: "/add-price-component", component: AddPriceComponent },
  {
    path: "/edit-price-component/:priceComponentId",
    component: EditPriceComponent,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
];

const hourCollectionsRoutes = [
  { path: "/hour-collections", component: HourCollectionsList },
];

const payslipeRoutes = [
  { path: "/payslipes", component: PayslipesList },
  { path: "/add-payslipe", component: AddPayslipe },
  { path: "/payslipe-details/:id", component: PayslipeDetails },
];

const internalPayslipeRoutes = [
  { path: "/internal-payslipes", component: InternalPayslipesList },
  {
    path: "/internal-payslipe-details/:id",
    component: InternalPayslipeDetails,
  },
  { path: "/add-internal-payslipe", component: AddInternalPayslipe },
];

const deductionsRoutes = [
  { path: "/deductions", component: DeductionsList },
  {
    path: "/add-deduction",
    component: AddDeduction,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
];

const InsuranceRoutes = [
  { path: "/insurance", component: InsuranceList },
  { path: "/add-insurance/:id", component: AddInsurance },
  { path: "/edit-insurance/:id", component: EditInsurance },
];

const LeavesRoutes = [
  { path: "/leaves", component: LeavesList },
  { path: "/add-leave/:id", component: AddLeave },
  { path: "/edit-leave/:id", component: EditLeave },
];

const workExperienceRoutes = [
  { path: "/add-work-experience/:id", component: AddWorkExperience },
  { path: "/edit-work-experience/:id", component: EditWorkExperience },
];

const educationRoutes = [
  { path: "/add-education/:id", component: AddEducation },
  { path: "/edit-education/:id", component: EditEducation },
];

const carsRentersRoutes = [
  { path: "/car-renters/:carId", component: CarRentersList },
];

const carsRoutes = [
  { path: "/cars", component: CarsList },
  { path: "/cars/:id", component: CarDetails },
  { path: "/add-car", component: AddCar },
  { path: "/edit-car/:id", component: EditCar },
  ...carsRentersRoutes,
];

const roomsRentersRoutes = [
  { path: "/room-renters/:roomId", component: RoomRentersList },
];

const housingRoomsRoutes = [
  { path: "/rooms/:housingId", component: RoomsList },
  { path: "/rooms/:housingId/:roomId", component: RoomDetails },
  { path: "/add-room/:housingId", component: AddRoom },
  { path: "/edit-room/:id", component: EditRoom },
  ...roomsRentersRoutes,
];

const housingRentersRoutes = [
  { path: "/housing-renters/:housingId", component: HousingRentersList },
];

const housingRoutes = [
  { path: "/housing", component: HousingList },
  { path: "/housing/:housingId", component: HousingDetails },
  { path: "/add-housing", component: AddHousing },
  { path: "/edit-housing/:id", component: EditHousing },
  ...housingRentersRoutes,
  ...housingRoomsRoutes,
];

const fineRoutes = [
  { path: "/fine/:reservationId", component: FineList },
  { path: "/add-fine/:reservationId", component: AddFine },
  { path: "/edit-fine/:id", component: EditFine },
];

const personalUseRoutes = [
  { path: "/personal-use/:reservationId", component: PersonalUseList },
  { path: "/add-personal-use/:reservationId", component: AddPersonalUse },
  { path: "/edit-personal-use/:id", component: EditPersonalUse },
];

const reservationsRoutes = [
  { path: "/reservations", component: ReservationsList },
  { path: "/reservations/:reservationId", component: ReservationDetails },
  ...fineRoutes,
  ...personalUseRoutes,
];

const authProtectedRoutes = [
  ...adminRoutes,
  ...employeeRoutes,
  ...poolRoutes,
  ...companyRoutes,
  ...priceComponentRoutes,
  ...payslipeRoutes,
  ...internalPayslipeRoutes,
  ...deductionsRoutes,
  ...workExperienceRoutes,
  ...educationRoutes,
  ...InsuranceRoutes,
  ...LeavesRoutes,
  ...carsRoutes,
  ...housingRoutes,
  ...reservationsRoutes,
  ...hourCollectionsRoutes,
  { path: "/contracts", component: MyContractsList },

  { path: "/company/:id/contracts", component: ContractsList },
  {
    path: "/company/:id/add-contract",
    component: AddContract,
    // permission: PERMISSIONS.ROLE_CREATE,
  },

  {
    path: "/edit-contract/:contractId",
    component: EditContract,
    // permission: PERMISSIONS.ROLE_EDIT,
  },

  { path: "/pool-hours/:poolId", component: CollectionsList },
  {
    path: "/add-collection/:poolId",
    component: AddCollection,
    // permission: PERMISSIONS.ROLE_CREATE,
  },
  {
    path: "/edit-collection/:id",
    component: EditCollection,
    // permission: PERMISSIONS.ROLE_EDIT,
  },
  ...invoiceableRoutes,
  ...invoiceRoutes,

  { path: "/", exact: true, component: () => <Redirect to="/companies" /> },
];

const tFARoutes = [
  { path: "/two-factor-authintication", component: TwoFactorAuth },
];

const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/login-two-factor-authintication", component: LoginTwoFactorAuth },
  { path: "/forgot-password", component: ForgotPassword },
  { path: "/reset-password", component: ResetPassword },
];

export { authProtectedRoutes, publicRoutes, tFARoutes };
